<template>
  <Dialog :open="showModal" @update:open="emit('close')">
    <DialogContent>
      <DialogHeader class="items-center">
        <FailureIcon v-if="isError" />
        <SuccessIcon v-else />
        <DialogTitle>{{ title }}</DialogTitle>
        <DialogDescription>
          {{ description }}
        </DialogDescription>
      </DialogHeader>

      <SectionDivider className="mb-1" />

      <DialogFooter>
        <Button @click="emit('close')" :class="{ 'w-[100px]': isDesktop }">Done</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
</template>

<script setup lang="ts">
import SectionDivider from '@/components/common/SectionDivider.vue';
import FailureIcon from '@/components/icons/FailureIcon.vue';
import SuccessIcon from '@/components/icons/SuccessIcon.vue';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { useBreakpoint } from '@/utils/useBreakPoint';

const emit = defineEmits(['close', 'update:show-modal']);

const { isDesktop } = useBreakpoint();

defineProps({
  showModal: {
    type: Boolean,
    required: true,
  },
  description: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  isError: {
    type: Boolean,
    required: false,
  },
});
</script>
